/* Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. */

import { fancyConfig } from '../FancyConfig';
import { IProjectCatalogData } from '../interfaces/IProjectCatalog';

interface IMasterCatalog {
	catalog(): IProjectCatalogData;
}

//them es6 workarounds...
export const masterCatalog: IMasterCatalog = {
	catalog() {
		return {
			databaseName: 'master', //default db doesn't technically have a name
			databaseURL: fancyConfig.firebaseDatabaseUrl,
			updatedAt: '', //TODO - figure out a good value to set this to
		} as IProjectCatalogData;
	},
};
